import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const PrivateRoute = ({ component: Component, isAuthenticate, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticate) {
        return <Component {...props} />;
      } else {
        return <Redirect to="/login" />;
      }
    }}
  />
);

const mapStateToProps = state => ({
  isAuthenticate: state.authentication.isAuthenticate
});

export default connect(mapStateToProps)(PrivateRoute);
